import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MaterialModule } from './material.module';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CertSelectorComponent } from '@app/certificates/cert-selector/cert-selector.component';
import { ProfileRemainingCountComponent } from '@app/profile/profile-remaining-count/profile-remaining-count.component';
import { CqesIconComponent } from '../cqes-icon/cqes-icon.component';
import { MatTableModule } from '@angular/material/table';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ProfileService } from '@app/core/services/profile/profile.service';
import { FileSizePipe } from '../pipes/filesize-pipe';
import { DragDropModule } from '@angular/cdk/drag-drop'
import { HistoryTableSpinnerComponent } from '../spinners/history-table-spinner/history-table-spinner.component';
import { ResizableColumnDirective } from '../directives/resizable-column.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    TranslateModule,
    DragDropModule
  ],
  declarations: [
    CertSelectorComponent,
    CqesIconComponent,
    ProfileRemainingCountComponent,
    FileSizePipe,
    HistoryTableSpinnerComponent,
    ResizableColumnDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MaterialModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CertSelectorComponent,
    ProfileRemainingCountComponent,
    RouterModule,
    CqesIconComponent,
    MatTableModule,
    FileSizePipe,
    DragDropModule,
    HistoryTableSpinnerComponent,
    ResizableColumnDirective
  ],
  providers: [
    ProfileService
  ]
})
export class SharedModule {}
